import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SectionHeading from "@/components/SectionHeading";
import Gallery from "@/components/Gallery";
import HeroSection from "@/components/HeroSection";

const Granit = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection
          title="Granit"
          subtitle="Klasična lepota granita"
          imageSrc="/placeholder.svg"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />
        
        <div className="container-custom mx-auto py-16">
          <SectionHeading
            title="Granit"
            subtitle="Klasična lepota granita"
          />
          
          <div className="mt-8 prose prose-lg max-w-none">
            <p>
              Granit je eden izmed najbolj priljubljenih naravnih kamnov, ki navdušuje s svojo trdnostjo, trajnostjo in naravno lepoto.
              Njegova raznolikost vzorcev in barv omogoča številne možnosti oblikovanja v domačem ali poslovnem okolju.
            </p>
          </div>
          
          <Gallery
            images={[
              { src: "/placeholder.svg", alt: "Granit 1" },
              { src: "/placeholder.svg", alt: "Granit 2" },
              { src: "/placeholder.svg", alt: "Granit 3" },
              { src: "/placeholder.svg", alt: "Granit 4" },
            ]}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Granit;